import styled from 'styled-components';

export const PageContainer = styled.div`
  margin: auto;
  max-width: 850px;
  width: 100%;
`;
